import router from '../../router'
import NavigationBar from '../../components/navigation-bar/NavigationBar'
import Loader from '../../components/loader/Loader'
import moment from 'moment'
import { ScreenLoader } from '../../utils/loading.util'
import { LocationService, LocationDropdown, Location } from '../../services/location.service'
import { StatusDropdown, StatusService, Status } from '../../services/status.service'
import { ArrivalService, Arrivals, Arrival } from '../../services/arrival.service'
import InputDropdown from '../../components/input-dropdown/InputDropdown'
import InputDropdownCheckbox from '../../components/input-dropdown-checkbox/InputDropdownCheckbox'
import InputDatePicker from '../../components/input-date-picker/InputDatePicker'
import ArrivalCard from '../../components/arrival/Arrival'
import {TimezoneService} from "@/services/timezone.service";
import {KeycloakService} from "@/services/keycloak.service";
import {CookieService} from "@/services/cookie.service";

export default {
    name: 'Arrivals',
    components: {
        NavigationBar,
        Loader,
        InputDropdown,
        InputDropdownCheckbox,
        InputDatePicker,
        ArrivalCard
    },

    data() {
        return {
            selectedDate: new Date(),
            arrivals: new Arrivals(),
            dropdownLocations: [],
            dropdownStatus: [],
            dropdownStatusValue: '',
            locations: [],
            locationId: undefined,
            location: new Location(),
            screenLoader: new ScreenLoader(),
            dockIntegration: false,
            showHandling: false,
            preference: undefined,
            cookieName: "arrivals"
        }
    },

    async mounted() {
        if (this.$route.query.date) {
            this.selectedDate = new Date(this.$route.query.date)
        }
        this.dockIntegration = process.env.VUE_APP_DOCK_INTEGRATION_PRESENT === 'true'
        this.showHandling = process.env.VUE_APP_HIDE_HANDLING === 'false'

        try {
            this.preference = CookieService.getCookie(this.cookieName)
            this.locationId = this.preference?.location ?? this.$route.query.locationid
        } catch (e) {
            this.locationId = undefined
        }
        await this.getLocations()

    },
    computed: {
        isBookingAgent() {
            return KeycloakService.isBookingAgent()
        },
    },

    methods: {
        reload() {
            if (this.locations.length == 0) {
                this.getLocations()
            } else {
                this.getArrivals()
            }
        },

        getLocations: async function() {
            this.screenLoader.start(['locations'])
            this.isLocationsLoading = true

            try {
                const locations = await LocationService.getLocations()
                await this.handleLocationsResponse(locations)
            } catch (error) {
                this.screenLoader.stopWithError(error, ['locations'])
            }
        },

        getArrivals: async function() {
            this.screenLoader.start()

            try {
                const arrivals = await ArrivalService.getArrivals(this.location.id, this.selectedDate)
                this.handleArrivalsResponse(arrivals)
            }catch(error) {
                this.screenLoader.stopWithError(error)
            }
        },

        async handleLocationsResponse(locations) {
            this.locations = locations.map(o => new Location(o))
            this.dropdownLocations = locations.map(o => new LocationDropdown(o))

            const locationId = this.locationId ?? this.dropdownLocations[0].id
            await this.updateLocation(locationId)
        },

        handleArrivalsResponse(arrivals) {
            this.arrivals = new Arrivals(arrivals)
            //correct timezone
            this.arrivals = TimezoneService.correctTimezoneDifferenceArrivals(this.arrivals, this.location)

            const status = []
            for (const property in this.arrivals) {
                const statusDropdown = new StatusDropdown()
                // catch case onDock since its two words
                if (property.charAt(0) === "o") statusDropdown.value = "On Dock"
                else statusDropdown.value = property.charAt(0).toUpperCase() + property.slice(1);
                status.push(statusDropdown)
            }

            this.dropdownStatus = this.dropdownStatus.length == 0 ? status : this.dropdownStatus
            this.screenLoader.stop()

            const start = moment(this.selectedDate).startOf('day').toISOString()
            if (start != this.$route.query.date || this.location.id != this.$route.query.locationid) {
                router.push(`/arrivals?locationid=${this.location.id}&date=${start}`)
            }
        },

        updateSelectedDate(date) {
            if (this.selectedDate != date) {
                this.selectedDate = date
                this.getArrivals()
            }
        },

        updateLocation: async function(id) {
            this.location = this.locations.filter(location => location.id == id)[0]
            this.location = await LocationService.getLocation(this.location.id)
            this.setPreference()
            await this.getArrivals()
        },

        updateStatus() {
            const values = this.getDropdownValues(this.dropdownStatus)
            this.dropdownStatusValue = values.join(', ')
        },

        getDropdownValues(dropdownItems) {
            const values = []
            for (const dropdownItem of dropdownItems) {
                if (dropdownItem.checked) {
                    values.push(dropdownItem.value)
                }
            }
            return values
        },

        showColumn(name) {
            const show = this.dropdownStatus.filter(o => o.value.toLowerCase() == name.toLowerCase() && o.checked)
            return show.length > 0 || this.dropdownStatusValue == ''
        },

        columnWidth() {
            const checkedAmount = this.dropdownStatus.filter(o => o.checked).length
            return checkedAmount == 0 ? '33%' : Math.floor(100 / checkedAmount) + '%'
        },

        setPreference() {
            const cookie = {
                "location": this.location.id
            }
            CookieService.storeCookie(this.cookieName, cookie, 365)
        }
    }
}
